import React, { useEffect, useState } from 'react';
import style from './animatedSprite.module.css';
import spriteSheet from '../../images/spriteSheet.svg';


const AnimatedSprite = ({ visibleElements, elementsRef }) => {
  const [currentFrame, setCurrentFrame] = useState(1);
  const [repeatCount, setRepeatCount] = useState(0);
  const totalFrames = 13;
  const spriteWidth = 200;
  const spriteHeight = 200;
  const spriteSpacing = 10;

  useEffect(() => {
    const interval = setInterval(() => {
      if (visibleElements.includes(elementsRef.current[18])) {
        setCurrentFrame((prevFrame) => {
          if (prevFrame === 7 || prevFrame === 8) {
            if (repeatCount < 3) {
              setRepeatCount((count) => count + 1);
              return prevFrame === 7 ? 8 : 7;
            } else {
              setRepeatCount(0);
              return prevFrame === 8 ? 9 : 8;
            }
          }

          if (prevFrame === 1) {
            if (repeatCount < 6) {
              setRepeatCount((count) => count + 1);
              return 1;
            } else {
              setRepeatCount(0);
              return 2;
            }
          }

          if (prevFrame < totalFrames) {
            return prevFrame + 1;
          } else {
            clearInterval(interval);
            return prevFrame;
          }
        });
      }
    }, 150);

    return () => clearInterval(interval);
  }, [visibleElements, elementsRef, repeatCount]);

  const spritesPerRow = 4;
  const offsetX = ((currentFrame - 1) % spritesPerRow) * (spriteWidth + spriteSpacing);
  const offsetY = Math.floor((currentFrame - 1) / spritesPerRow) * (spriteHeight + spriteSpacing);

  return (
    <div className={`${style['sprite']}
    ${visibleElements.includes(elementsRef.current[18]) ?
    style['sprite--transition']: ''}`}>
      
      <svg
        width={spriteWidth}
        height={spriteHeight}
        viewBox={`${offsetX} ${offsetY} ${spriteWidth} ${spriteHeight}`}
      >

        <image
          href={spriteSheet}
          width={840}
          height={840}
        />

      </svg>

    </div>
  );
};

export default AnimatedSprite;
